// Helpers for dynamic table columns
export function visibleColumns(columns) {
  return columns.filter(({ visible }) => !(visible === false))
}

export function discoverColumns(data = [], columns = []) {
  if (!data || data.length === 0) return columns

  // Collect all keys from data
  const allKeys = new Set()
  data.forEach((item) => {
    Object.keys(item).forEach((key) => {
      allKeys.add(key)
    })
  })

  // Map existing columns for quick lookup
  const existingColumnsMap = new Map(columns.map((col) => [col.key, col]))

  const mergedColumns = []
  // Add predefined columns first
  columns.forEach((col) => {
    mergedColumns.push(col)
  })

  // Add any missing columns discovered from data
  allKeys.forEach((key) => {
    if (!existingColumnsMap.has(key)) {
      mergedColumns.push({
        key,
        label: key.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase()),
        visible: false,
        sortable: true,
      })
    }
  })

  return mergedColumns.filter(({ key }) => key !== 'actions')
}

export default {
  visibleColumns,
  discoverColumns,
}
